import { render, staticRenderFns } from "./fishColorful.vue?vue&type=template&id=170a3356"
import script from "./fishColorful.vue?vue&type=script&lang=js"
export * from "./fishColorful.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports